import UploadFileIcon from '@mui/icons-material/UploadFile';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';
import SearchIcon from '@mui/icons-material/Search';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  marginBottom: '24px',
});

export const StyledUploadFileIcon = styled(UploadFileIcon)({
  color: COLORS.secondary,
  fontSize: '40px',
  '&:hover': {
    color: COLORS.primary,
  }
});

export const StyledSearchIcon = styled(SearchIcon)({
  color: COLORS.secondary,
  fontSize: '40px',
  '&:hover': {
    color: COLORS.primary,
    cursor: 'pointer'
  }
});

export const InputFileButtonContainer = styled('label')({
  display: 'inline-block',
  cursor: 'pointer',
});

export const InputFile = styled('input')({
  display: 'none'
});

export const RowContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  width: '100%'
});

export const RowSeparator = styled('div')({
  width: '20px'
});

export const PaginationContainer = styled('div')({
  display: 'flex',
  alignSelf: 'center',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'center'
});

/* ── Modern Drag & Drop Zone Styles ── */

export const DropZoneContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDragging' && prop !== 'disabled',
})(({ isDragging, disabled }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px 20px',
  border: isDragging ? `2px dashed ${COLORS.primary}` : `2px dashed #CBD5E1`,
  borderRadius: '16px',
  backgroundColor: isDragging ? 'rgba(32, 42, 93, 0.04)' : '#F8FAFC',
  cursor: disabled ? 'not-allowed' : 'pointer',
  transition: 'all 0.2s ease-in-out',
  opacity: disabled ? 0.6 : 1,
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'center',
  outline: 'none',
  '&:hover': {
    borderColor: disabled ? '#CBD5E1' : COLORS.primary,
    backgroundColor: disabled ? '#F8FAFC' : 'rgba(32, 42, 93, 0.02)',
  }
}));

export const DropZoneTitle = styled('p')({
  margin: '10px 0 4px 0',
  fontSize: '13px',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: '600',
  color: '#334155',
  lineHeight: '1.4',
});

export const DropZoneSubtitle = styled('span')({
  fontSize: '11px',
  color: '#64748B',
  display: 'block',
  marginTop: '2px',
});

export const FileCardContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  border: '1px solid #E2E8F0',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  width: '100%',
  marginTop: '12px',
  transition: 'all 0.15s ease-in-out',
  '&:hover': {
    borderColor: '#CBD5E1',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
  },
  'body.admin-shell &:hover': {
    boxShadow: 'none',
  }
});

export const FileCardInfo = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  flex: 1,
  minWidth: 0,
});

export const FileCardName = styled('p')({
  margin: 0,
  fontSize: '13.5px',
  fontWeight: '500',
  color: '#1E293B',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontFamily: 'inherit',
});

export const FileCardSize = styled('span')({
  fontSize: '12px',
  color: '#64748B',
  fontWeight: '400',
});

export const FileCardActionWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginLeft: '12px',
});